// Configuração centralizada para caminhos das imagens
// Usa configuração de ambiente para detectar automaticamente

import { CONFIG } from './environment';

export const IMAGE_PATHS = {
  // Hero Section
  hero: `${CONFIG.IMAGE_BASE_PATH}/hero_image.png`,
  heroWoman: `${CONFIG.IMAGE_BASE_PATH}/hero_woman.png`,
  seloAnvisa: `${CONFIG.IMAGE_BASE_PATH}/seloanvisa.png`,
  homemTriste: `${CONFIG.IMAGE_BASE_PATH}/homem_triste.png`,
  mulherAcademia: `${CONFIG.IMAGE_BASE_PATH}/mulher_academia.png`,
  mulherImagine: `${CONFIG.IMAGE_BASE_PATH}/mulher.png`,
  
  // Pain Points Section (Depoimentos)
  patricia: `${CONFIG.IMAGE_BASE_PATH}/patricia.JPG`,
  felipe: `${CONFIG.IMAGE_BASE_PATH}/felipe.JPG`,
  renata: `${CONFIG.IMAGE_BASE_PATH}/renata.JPG`,
  
  // Story Section
  magrisim: `${CONFIG.IMAGE_BASE_PATH}/magrisim.png`,
  anvisa: `${CONFIG.IMAGE_BASE_PATH}/anvisa.png`,
  beneficios: `${CONFIG.IMAGE_BASE_PATH}/beneficios.png`,
  
  // Benefits Section
  ansiedade: `${CONFIG.IMAGE_BASE_PATH}/ansiedade.png`,
  metabolismo: `${CONFIG.IMAGE_BASE_PATH}/metabolismo.png`,
  gorda: `${CONFIG.IMAGE_BASE_PATH}/gorda.png`,
  aprovado: `${CONFIG.IMAGE_BASE_PATH}/aprovado.png`,
  
  // Science Section
  morosil: `${CONFIG.IMAGE_BASE_PATH}/morosil.png`,
  cromo: `${CONFIG.IMAGE_BASE_PATH}/cromo.png`,
  slendesta: `${CONFIG.IMAGE_BASE_PATH}/slendesta.png`,
  faseolamina: `${CONFIG.IMAGE_BASE_PATH}/faseolamina.png`,
  lTriptofano: `${CONFIG.IMAGE_BASE_PATH}/l-triptofano.png`,
  
  // Section Six
  sublingual: `${CONFIG.IMAGE_BASE_PATH}/sublingual.png`,

  // Custo dos ativos
  componentes: `${CONFIG.IMAGE_BASE_PATH}/componentes.png`,
  
  // Offer Section
  magrisim1: `${CONFIG.IMAGE_BASE_PATH}/magrisim_1_pot.png`,
  magrisim3: `${CONFIG.IMAGE_BASE_PATH}/magrisim_3_pots.png`,
  magrisim5: `${CONFIG.IMAGE_BASE_PATH}/magrisim_5_pots.png`,
  frasco5: `${CONFIG.IMAGE_BASE_PATH}/5frasco.png`,
  frasco3: `${CONFIG.IMAGE_BASE_PATH}/3frasco.png`,
  frasco1: `${CONFIG.IMAGE_BASE_PATH}/1frasco.png`,
};

console.log('🖼️ IMAGE_PATHS configurado para:', CONFIG.ENVIRONMENT);
console.log('Base path das imagens:', CONFIG.IMAGE_BASE_PATH);

